export enum ClassesPathEnum {
  SCHEDULE = "/schedule",
}
